<template>
  <section
    class="d-flex flex-row rounded-4 py-2 px-4 shadow bg-blue-300"
  >
    <div class="d-flex flex-column text-left">
      <div class="h5 mb-2">
        {{ company.name.toUpperCase() }}
      </div>
      <div> {{ formattedCard }} </div>
    </div>
    <div class="d-flex flex-column ms-auto text-blue-700">
      <div class="mb-2">
        Expire le {{ expirationDate }}
      </div>
      <div> {{ brand }} </div>
    </div>
    <div class="d-flex ms-auto my-auto">
      <span
        class="badge badge-pill rounded-pill px-2 fs-6 fw-bold lead"
        :class="isActive ? 'bg-green-300' : 'bg-gray-300 cursor-pointer'"
        style="min-width: 120px"
        @click="activateCard"
      >
        {{ isActive ? 'Principale' : 'Changer en principale' }}
      </span>
    </div>
    <div
      class="my-auto ms-2"
      :class="isActive ? 'invisible' : 'd-flex' "
    >
      <v-loading-icon
        :action="deleteCard"
      />
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex';
import { ui } from '@/mixins';

import LoaderIcon from '@/components/common/helpers/LoaderIcon.vue';

export default {
  components: {
    'v-loading-icon': LoaderIcon,
  },
  mixins: [ui],
  props: {
    creditCard: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters({
      company: 'company/get',
    }),
    isActive() {
      return this.creditCard.active;
    },
    formattedCard() {
      return `N° **** **** **** ${this.creditCard.lastNumbers}`;
    },
    expirationDate() {
      return this.creditCard.expirationDate;
    },
    brand() {
      return this.creditCard.brand.toUpperCase();
    },
  },
  methods: {
    deleteCard() {
      if (this.isActive) { return Promise.resolve() }
      const action = async () => {
        await this.$store.dispatch('payments/removePaymentMethod', this.creditCard.id);
        await this.$store.dispatch('payments/getPaymentMethods');
      };
      this.ui_accountModal({ type: 'deleteCreditCard', value: true, action });
      return Promise.resolve();
    },
    activateCard() {
      if (!this.isActive) {
        const action = () => this.$store.dispatch('payments/activatePaymentMethodFromId', this.creditCard.id);
        this.ui_accountModal({ type: 'activateCreditCard', value: true, action });
      }
    },
  },
};
</script>
